import React from "react";
import { Link } from "react-router-dom";

function ContactInfoBanner() {
  return (
    <section className="headOfficeWrapper py-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="headOfficeImg">
              <img src="/assets/images/contact-img1.webp" alt="" />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="headOfficeHldr">
              <h2 className="titleMain">HEAD OFFICE</h2>
              <div className="headOfficeAddress">
                <h2>JB EMPORIUM INDIA PVT LTD</h2>
                <p>Plot No. 1516/7B, Ward-31,</p>
                <p>Daulatabad Industrial Area,</p>
                <p>Gurgaon - 122 006, Haryana, </p>
                <p>India.</p>
              </div>
              <div className="contactInfo">
                <h2 className="mb-3">Contact Info</h2>
                <p className="mb-3">
                  <Link to={"mailto:query@jbglass.in"}>
                    <i className="fa fa-envelope me-1"></i> query@jbglass.in
                  </Link>
                </p>
                <p>
                  <Link to={"tel:+918800994444"}>
                    <i className="fa fa-phone me-1"></i> +91 8800994444
                  </Link>
                </p>
                <p className="mt-3">
                  <Link
                    to={"https://bit.ly/Waltz_Innovation_Center"}
                    target="_blank"
                    style={{ color: "#0b44ef", textDecoration: "none" }}
                  >
                    <i className="fa fa-map-marker me-1"></i> Click For Map
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactInfoBanner;
